import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { AuthService } from '../../../services-http/auth/auth.service';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { NotificationService } from '../../../services-http/notification/notification.service'
import Swal from 'sweetalert2'


@Component({
  selector: 'app-cac',
  templateUrl: './cac.component.html',
  styleUrls: ['./cac.component.scss']
})
export class CacComponent implements OnInit, AfterViewInit {
  @ViewChild('frame') frame: ModalDirective;
  @ViewChild('basicModal') basicModal: ModalDirective;
  @ViewChild('pop') pop: any;


  user:any = JSON.parse(localStorage.getItem('currentUser'));
  userType:any;
  coopName:any;
  unreadNotifCount:any=0;

  constructor(
    private authService: AuthService,
    private router: Router,
    public notification:NotificationService
  ) {

    this.notification.connect(this.user);
      // register ang user bai using userid
        this.notification.ws.onopen = () => {
          console.log('Connected to server');
    
          const payload = {
            type: "register",
            user_id: this.user.iloginId
          };
          this.notification.ws.send(JSON.stringify(payload));
        };
      
        this.notification.ws.onmessage = (event) => {
       
          this.unreadNotifCount++;
          this.notification.playSound();
        };
      
        this.notification.ws.onclose = () => {
          // Swal.fire(
          //   'Error',
          //   'Connection closed, realtime notification is not available.',
          //   'error'
          // );
      console.log('Connection closed, realtime notification is not available.');

        };
      
    
        this.notification.ws.onerror = (error) => {
          // Swal.fire(
          //   'Error',
          //   'WebSocket error' + error,
          //   'error'
          // );
      console.log('WebSocket error' + error);

        };

  }

  closeNotificationPopover = () => {
    if (this.pop) {
      this.pop.hide();
    }
  };

  

  ngAfterViewInit() {

    if(this.user.checkunpayed){
      this.basicModal.show();
    }
  }


  logout() {
    this.authService.logout();
  }
  
   
  gotoProfileView() {
    this.router.navigateByUrl('/cac/cac-profile/' + this.user['userId'] + '/view');
  }

  

  ngOnInit() {     
    this.getnotif()
  
  }



  getnotif(){
    this.notification.getNotification(this.user.iloginId)
      .subscribe((res: any) => {
        
        this.unreadNotifCount = res.filter((x:any) => x.status == 1).length;
    })
  }

}
